export default "__VITE_ASSET__BKqFDZru__"